<template>
    <div class="py-4 container-fluid">
        <transition name="banner-slide">
            <div v-if="isSyncing || progress === 100">
                <RvoSyncBanner />
            </div>
        </transition>
        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-10 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('departure.UBN')" :class="activeStep >= 0 ? activeClass : ''"
                                                @click="activeStep = 0">
                                                <span>{{ $t('departure.UBN') }}</span>
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('departure.Animal')" :class="activeStep >= 1 ? activeClass : ''"
                                                @click="activeStep = 1">
                                                <span>{{ $t('departure.Animal') }}</span>
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('departure.Departure_UBN')"
                                                :class="activeStep >= 2 ? activeClass : ''" @click="activeStep = 2">
                                                {{ $t('departure.Departure_UBN') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('departure.Departure_Date')"
                                                :class="activeStep >= 3 ? activeClass : ''" @click="activeStep = 3">
                                                {{ $t('departure.Departure_Date') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <form class="multisteps-form__form" @submit.prevent="submitForm">
                                        <ubn-info 
                                            v-if="activeStep === 0" 
                                            :class="activeStep === 0 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep"                                            
                                            :ubns="formData.ubns"                                            
                                            @request-animals="handleAnimalRequest"
                                            @update:formData="updateFormData"
                                        />
                                        <animal-info 
                                            v-if="activeStep === 1" 
                                            :class="activeStep === 1 ? activeClass : ''"
                                            :formData="formData" 
                                            :prevStep="prevStep"
                                            :nextStep="nextStep"
                                            :animals="formData.animals"
                                            @update:formData="updateFormData"
                                        />
                                        <departure-info
                                            v-if="activeStep === 2" 
                                            :class="activeStep === 2 ? activeClass : ''"
                                            :formData="formData" 
                                            :departureubns="formData.departureubns"
                                            :exportcountries="formData.exportcountries"
                                            :prevStep="prevStep"
                                            :nextStep="nextStep" 
                                            @update:formData="updateFormData"
                                            @textbox-empty="enableDepartureDropdown"
                                            @textbox-has-text="disableDepartureDropdown"
                                        />
                                        <date-info 
                                            v-if="activeStep === 3" 
                                            :class="activeStep === 3 ? activeClass : ''"
                                            ref="dateInfoRef"
                                            :formData="formData"
                                            :prevStep="prevStep"
                                            :emitter="emitter"
                                        />
                                        <div class="button-row d-flex">
                                            <button
                                                v-if="activeStep === 3"
                                                @click="saveForm"
                                                :disabled="isSaving"
                                                :class="[
                                                    'btn mb-0 btn-sm bg-gradient-success ms-auto',
                                                    { 'disabled opacity-75': isSaving }
                                                ]"
                                                type="button"
                                            >
                                                <span v-if="isSaving" class="spinner-border spinner-border-sm me-2"></span>
                                                {{ isSaving ? $t('common.Saving') : $t('common.Save') }}
                                            </button>
                                        </div>                                      
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import RvoSyncBanner from "@/components/RvoSyncBanner.vue";
import UbnInfo from "./components/UBN.vue";
import AnimalInfo from "./components/Animal.vue";
import DepartureInfo from "./components/DepartureTo";
import DateInfo from "./components/Date.vue";
import * as Choices from "choices.js";
import { nextTick } from 'vue'
import axios from 'axios'
import mitt from 'mitt';
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'Departure_page',
    data() {
        return {
            emitter: mitt(),
            activeStep: 0,
            activeClass: "js-active position-relative",
            formSteps: 4,
            formData: {
                associationId: '',
                ubnId: '',
                animalIds: '',
                departureUbnId: '',
                departureUbn: '',
                exportCountryId: '',
                departureDate: null,
                ubns:[],
                departureubns:[],
                animals:[],
                exportcountries:[]
            },
            // Store Choices instance            
            choicesInstanceUBN: null,
            choicesInstanceDepartureUBN: null,
            choicesInstanceAnimal: null,
            choicesExportCountry: null,            
            isSaving: false
        };
    },
    components: {
        UbnInfo,
        AnimalInfo,        
        DepartureInfo,
        DateInfo,
        RvoSyncBanner
    },
    async mounted() 
    {
        try {  
            this.associationId = this.$route.params.id;
            await this.fetchAllUBN();

        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
    },    
    computed: {
        userRoleName() {
            return this.$store.state.user?.roleName;
        },
        ...mapState('rvoSync', ['isSyncing', 'progress', 'cancelSource']),
        ...mapGetters('rvoSync', ['elapsedSeconds'])
    },
    methods: {        
        disableDepartureDropdown() {
            // Clear any existing selection so it doesn’t block focus/selection state
            if (this.choicesInstanceDepartureUBN) {
                this.choicesInstanceDepartureUBN.removeActiveItems(); // clears selected
                this.choicesInstanceDepartureUBN.disable();           // disable via Choices API
            }
        },

        enableDepartureDropdown() {
            if (this.choicesInstanceDepartureUBN) {
                this.choicesInstanceDepartureUBN.enable();            // enable via Choices API only
            }
        },
        async nextStep() {
            if (this.activeStep < this.formSteps -1) {
                this.activeStep += 1;
                //console.log(this.activeStep);
            } else {
                this.activeStep -= 1;
                //console.log(this.activeStep);
            }   

            if(this.activeStep == 2) {
                await this.fetchAllUBN();
                await this.fetchAllDepartureUBN();
                await this.fetchAllExportCountry();
            }
        },
        async prevStep() {
            if (this.activeStep > 0) {
                this.activeStep -= 1;
                //console.log(this.activeStep);

                if(this.activeStep == 0) {
                    //await this.fetchAllUBNData();
                    await this.fetchAllUBN();
                }
                
                if(this.activeStep == 1) {
                    //await this.fetchAllAnimals();
                }

                if(this.activeStep == 2) {
                    await this.fetchAllUBN();
                    await this.fetchAllDepartureUBN();
                    await this.fetchAllExportCountry();
                }
            }
        },        
        async fetchAllUBN() 
        {
            try { 
                this.$store.commit('setShowLoading', true);

                const role = this.$store.state.roleName;
                const ubnId = this.$store.state.keeperLocationId;

                const response = await axios.get("Location/getallbyassociationdeparture", {
                    params: {
                        associationId: this.associationId
                    }
                });                
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    let avl_ubns = result.data;

                    if (role === 'Keeper' && ubnId) { 
                        avl_ubns = avl_ubns.filter(l => l.id === ubnId);

                        if (avl_ubns.length) {
                            this.formData.ubnId = avl_ubns[0].id;
                            this.formData.ubn = `${avl_ubns[0].ubn} - ${avl_ubns[0].locationFullAddressDropDown}`;
                        }
                    }

                    this.formData.ubns = avl_ubns;
                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "ubnId",
                        dataList: this.formData.ubns,
                        selectedValue: this.formData.ubnId,
                        instanceKey: "choicesInstanceUBN"
                    });
                } else {    
                    this.$showSuccess('errors.Error_fetching_ubns');
                }                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },        
        async fetchAllDepartureUBN()
        {
            this.$store.commit('setShowLoading', true);
            try { 
                const response = await axios.get("Location/getallbyassociationdeparture", {
                    params: {
                        associationId: this.associationId
                    }
                });
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    let avl_dubns = result.data;
                    
                    let ubnId = this.formData.ubnId;
                
                    if (ubnId) {                        
                        avl_dubns = avl_dubns.filter(l => l.id !== ubnId);
                    }

                    this.formData.departureubns = avl_dubns;
                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "departureUbnId",
                        dataList: this.formData.departureubns,
                        selectedValue: this.formData.departureUbnId,
                        instanceKey: "choicesInstanceDepartureUBN"
                    });
                } else {    
                    this.$showSuccess('errors.Error_fetching_ubns');
                }   
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        async fetchAllExportCountry()
        {
            this.$store.commit('setShowLoading', true);
            try {
                const response = await axios.get("reference/getreference", {
                    params: {
                        referenceTypeId: '8e7cedbf-891f-481e-bb84-07efd0aa8188'
                    }
                });
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    
                    this.formData.exportcountries = result.data;
                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "exportCountryId",
                        dataList: this.formData.exportcountries,
                        selectedValue: this.formData.exportCountryId,
                        instanceKey: "choicesExportCountry"
                    });
                } else {    
                    this.$showSuccess('errors.Error_fetching_export_country');
                }                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        async handleAnimalRequest({ ubnId }) {
            this.formData.associationId = this.$route.params.id;
            this.formData.ubnId = ubnId;

            this.$store.commit('setShowLoading', true);
            try {
                const response = await axios.get("Animal/getalldeparture", {
                    params: {
                        associationId: this.$route.params.id,
                        animalTypeId: '1469f04a-a84e-48a5-b79b-bd69f3a5bd51',
                        ubnId
                    }
                });
                if (response.data.success) {
                    if(response.data.count > 0 && Array.isArray(response.data.data)) {
                        this.formData.animals = response.data.data.sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));
                        this.nextStep();
                    } else {
                        this.$showSuccess('errors.Success_no_animal_found');
                    }
                } else {
                    this.$showError(this.$t('errors.Error_fetching_animals'));
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },              
        initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
            const element = document.getElementById(id);
            if (!element || element.tagName !== "SELECT") {
                console.error(`Choices: Invalid or missing select element with ID "${id}".`);
                return;
            }

            // Destroy previous instance if it exists
            if (this[instanceKey]) {
                this[instanceKey].destroy();
            }

            // Initialize new Choices instance
            this[instanceKey] = new Choices(element, {
                searchEnabled: true,
                itemSelectText: '',
                shouldSort: false,
                placeholder: true,
            });

            // Set selected value if it exists in list
            if (selectedValue) {
                const optionExists = dataList.some(item => item.id === selectedValue);
                this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
            }

             this.$nextTick(() => {
                const hasText = !!(this.formData.departureUbn && String(this.formData.departureUbn).trim());
                if (hasText) {
                    this[instanceKey].removeActiveItems();
                    this[instanceKey].disable();
                } else {
                    this[instanceKey].enable();
                }
            });
        },
        updateFormData(updatedData) {
            //this.formData = { ...this.formData, ...updatedData };
            Object.assign(this.formData, updatedData);
        },  
        async saveForm() {
            if (this.isSaving) return; // prevent double click
            this.isSaving = true;

            try {
                const isValid = await this.$refs.dateInfoRef?.validateAndSubmit();
                if (!isValid) {
                    this.isSaving = false;
                    return;
                }

                await this.submitForm();

            } catch (e) {
                console.error(e);
            } finally {
                this.isSaving = false;
            }
        },
        async submitForm() {
            this.$store.commit("setShowLoading", true);

            try {
                // Build FormData
                const formData = new FormData();
                const ignoredKeys = [
                                    'ubns', 'departureubns', 'animals', 'exportCountries'
                                ];

                for (const key of Object.keys(this.formData)) {

                    if (ignoredKeys.includes(key))
                        continue;

                    const value = this.formData[key];

                    if (key === "departureDate" && value instanceof Date) {
                        formData.append(
                            key,
                            value.toISOString().split("T")[0]
                        );
                    }
                    else if (value !== null && value !== undefined) {
                        formData.append(key, value);
                    }
                }

                // Debug
                for (let pair of formData.entries()) {
                    console.log(pair[0], pair[1]);
                }

                // Save departure locally
                const response = await axios.post("/departure/create",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                );

                const result = response.data;

                if (!result?.success)
                    throw new Error(result.message || "Form submission failed");

                const movementGroupId = result.data?.movementGroupId;
                
                const selectedAnimals = this.formData.animals.filter(a =>
                    this.formData.animalIds.includes(a.id)
                );

                if (!this.formData.departureUbn?.trim()) {

                    // Turn off global loader first
                    this.$store.commit("setShowLoading", false);

                    // Start Vuex RVO sync
                    const cancelSource = axios.CancelToken.source();
                    this.$store.commit('rvoSync/START_SYNC', cancelSource);

                    // Allow DOM to update and show banner
                    await this.$nextTick();

                    let rvoRes;

                    try {
                        if (selectedAnimals.length === 1) {

                            const animal = selectedAnimals[0];

                            const rvoPayloadSingle = {
                                rvoRelationNumber: this.$store.state.keeperRVORelationNumber,
                                animalUbn: this.formData.ubnId,
                                animalDepartureToUbn: this.formData.departureUbnId,
                                animalId: animal.id,
                                animalTagNumber: animal.tagNumber,
                                animalLandcode: animal.countryName,
                                departureDate: this.formData.departureDate
                            };

                            rvoRes = await axios.post(
                                "/rvo/syncrvodeparturesingle",
                                rvoPayloadSingle,
                                { cancelToken: cancelSource.token }
                            );

                        } else {

                            const rvoPayloadMultiple = {
                                rvoRelationNumber: this.$store.state.keeperRVORelationNumber,
                                animalUbn: this.formData.ubnId,
                                animalDepartureToUbn: this.formData.departureUbnId,
                                departureDate: this.formData.departureDate,
                                animals: selectedAnimals.map(a => ({
                                    animalTagNumber: a.tagNumber,
                                    animalLandcode: a.countryName,
                                    dierSoort: a.dierSoort ?? "3"
                                }))
                            };

                            rvoRes = await axios.post(
                                "/rvo/syncrvodeparturemultiple",
                                rvoPayloadMultiple,
                                { cancelToken: cancelSource.token }
                            );
                        }

                        // Handle RVO failure
                        if (!rvoRes?.data?.success) {

                            this.$showError(
                                rvoRes?.data?.message ||
                                this.$t("errors.RVO_sync_failed")
                            );

                            // Rollback
                            if (movementGroupId) {
                                try {
                                    await axios.delete(`/departure/group/${movementGroupId}`);
                                    console.warn("Departure rollback successful:", movementGroupId);
                                } catch (rollbackError) {
                                    console.error("Rollback failed", rollbackError);
                                }
                            }

                            return;
                        }

                    } catch (error) {

                        if (!axios.isCancel(error)) {
                            this.$showError(
                                error.response?.data?.message ||
                                error.message ||
                                this.$t("errors.Something_went_wrong")
                            );
                        }

                        return;

                    } finally {
                        // Stop Vuex RVO sync
                        this.$store.commit('rvoSync/STOP_SYNC');
                    }
                }

                // Success
                this.$showSuccess(this.$t("errors.Success_departure_created_successfully"));
                this.$router.push("/departure");
            }
            catch (e) {

                const errorMessage =
                    e.response?.data?.message ||
                    e.message ||
                    this.$t("errors.Something_went_wrong");

                this.$showError(
                    `${this.$t("errors.Contact_system_admin")}: ${errorMessage}`
                );
            }
            finally {
                this.$store.commit("setShowLoading", false);
            }
        }
    }
}
</script>
<style>

.choices[data-type*=select-one]::after {
  display: none !important;
}

.choices__inner {
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  position: relative;
}

.choices[data-type*=select-one] .choices__inner::before {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  width: 0;
  height: 0;
  pointer-events: none;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #666;
  transform: translateY(-50%);
}

/* Hide weird characters or fallback icons */
.choices__inner > *:not(.choices__item) {
  font-family: inherit !important;
  content: none !important;
}


.choices__placeholder {
  color: #999;
  font-style: italic;
}

.choices__list--single {
  padding: 0px !important;
}

.banner-slide-enter-active,
.banner-slide-leave-active {
    transition: all 0.4s ease;
}

.banner-slide-enter-from {
    transform: translateY(-20px);
    opacity: 0;
}

.banner-slide-leave-to {
    transform: translateY(-20px);
    opacity: 0;
}
</style>